class OrderItem {
    constructor({product, category, quantity, amount, order}) {
        this.className = 'OrderItemModel'

        this.product = product
        this.category = category
        this.quantity = quantity
        this.amount = amount
        this.order = order
    }

    hasProduct(product) {
        if (!product || !product.id) {
            throw new Error("product with id is required")
        }
        return this.product.id === product.id
    }

    hasCategory(category) {
        if (!category || !category.id) {
            throw new Error("category with id is required")
        }
        return this.category.id === category.id
    }

    hasProductAndCategory(product, category) {
        return this.hasProduct(product) && this.hasCategory(category)
    }
}

export default OrderItem;
